import { Sliders } from "react-feather";
import { useEffect, useState } from "react";
import { MetaSaleInfo, OutbidSale } from "@axvdex/types/solana/outbid";
import Button from "../../common/Button";
import CustomModal from "../../common/CustomModal";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import CreateSale from "./OperatorControls/CreateSale";
import AddIncentive from "./OperatorControls/AddIncentive";
import EndProcess from "./OperatorControls/EndProcess";
import Claim from "./OperatorControls/Claim";
import CancelSale from "./OperatorControls/CancelSale";

type ActionId = "createSale" | "addSaleIncentive" | "cancelSale" | "end" | "claim";
export type SolanaSaleOperatorControlsProps = {
  outbidSale: OutbidSale;
};

const SolanaSaleOperatorControls = ({ outbidSale }: SolanaSaleOperatorControlsProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    setActiveTab(null);
  }, [modalOpen]);

  const isActionDisabled = (actionID: ActionId) => {
    return false;
    if ("createSale" === actionID) {
      return !!Object.values(outbidSale.salesState).find(
        (sale: MetaSaleInfo) =>
          "WaitingToStart" === sale.status ||
          "WhitelistBidding" === sale.status ||
          "Bidding" === sale.status ||
          "BonusBidding" === sale.status
      );
    }

    if ("addSaleIncentive" === actionID) {
      return 0 >= Object.keys(outbidSale.salesState).length;
    }

    if ("end" === actionID) {
      return !!(
        0 === Object.keys(outbidSale.salesState).length ||
        Object.values(outbidSale.salesState).find(
          (sale: MetaSaleInfo) =>
            "WaitingToStart" === sale.status ||
            "WhitelistBidding" === sale.status ||
            "Bidding" === sale.status ||
            "BonusBidding" === sale.status
        )
      );
    }

    if ("claim" === actionID) {
      return !!(
        0 === Object.keys(outbidSale.salesState).length ||
        Object.values(outbidSale.salesState).find(
          (sale: MetaSaleInfo) =>
            "EndedSoldOut" === sale.status ||
            "EndedNotSoldOut" === sale.status ||
            "EndedBonusTimeSoldOut" === sale.status
        )
      );
    }

    if ("cancelSale" === actionID) {
      return false;
    }

    return true;
  };

  return (
    <>
      <Button
        btnVariant="icon"
        style={{ margin: "1em" }}
        onClick={e => {
          e.stopPropagation();
          setModalOpen(true);
        }}
      >
        <Sliders style={{ fontSize: "1em" }} />
      </Button>

      <CustomModal isOpen={modalOpen} onClose={() => setModalOpen(false)} modalSize="lg">
        <section className="sectionModalHeader">
          <h2 className="h2">{"Sale Operator Panel"}</h2>
        </section>
        <div style={{ textAlign: "center" }}>
          <ul className="btnGroup navTabs">
            {OPERATOR_ACTIONS.map(item => (
              <li key={item.id}>
                <Button
                  text={item.label}
                  extraClassName={item.id === activeTab && "isActive"}
                  onClick={() => setActiveTab(item.id)}
                  disabled={isActionDisabled(item.id)}
                />
              </li>
            ))}
          </ul>
          {activeTab === "createSale" && <CreateSale outbidSale={outbidSale} />}
          {activeTab === "addSaleIncentive" && <AddIncentive outbidSale={outbidSale} />}
          {activeTab === "end" && <EndProcess outbidSale={outbidSale} />}
          {activeTab === "claim" && <Claim outbidSale={outbidSale} />}
          {activeTab === "cancelSale" && <CancelSale outbidSale={outbidSale} />}
        </div>
      </CustomModal>
    </>
  );
};

export default SolanaSaleOperatorControls;

const OPERATOR_ACTIONS: { label: string; id: ActionId }[] = [
  {
    label: "Create Sale",
    id: "createSale",
  },
  {
    label: "Add Sale Incentive",
    id: "addSaleIncentive",
  },
  {
    label: "End Process",
    id: "end",
  },
  {
    label: "Claim Funds",
    id: "claim",
  },
  {
    label: "Cancel Sale",
    id: "cancelSale",
  },
];
